<!--
    ShowAdvert.vue
    Component to show a text of an advertizement for my services and products.
    by Guy E. White <guw968@g.harvard.edu>
-->
<template>
    <div id='advert'>
        <h2>Who is Dr. Guy?</h2>
        <p>Hi! I’m Dr. Guy, author of "<a href="https://www.amazon.com/dp/0984089519/?ref=exp_guyewhite_dp_vv_d" target="_blank">The Dissertation Warrior</a>" and Founder of <a href="https://www.thedissertationmentor.com/store/oeL9WYdw" target="_blank">The Dissertation Mentor® Accelerator Program</a>. I’ve helped thousands of doctoral candidates finish their dissertations and theses. If you’d like more help, you can find more about me and my work <a href="https://www.thedissertationmentor.com/" target="_blank">at my main website</a>.</p>
    </div>
</template>

<script>
export default {
    name: '',
    data: function() {
        return {};
    }
};
</script>

<style scoped>
</style>
